import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import styled from 'styled-components';
import FormTitle from './FormTitle';
import CommonButton from './CommonButton';

const ACCIDENT_TYPE = [
  '고지의무',
  '도수치료',
  '백내장',
  '남성질환',
  '여성질환',
  '대인배상',
  '재물(누수)손해',
  '진단금',
];

interface FormType {
  name: string;
  phoneNumber: string;
  insuranceType: string;
  insuranceName: string;
  // address: string;
  hospitalAddress: string;
  accidentType: string;
  insuranceAmount: string;
  description: string;
}

interface AccidentFormPropsType {
  form: FormType;
  setForm: Dispatch<SetStateAction<FormType>>;
}

const AccidentForm = ({ form, setForm }: AccidentFormPropsType) => {
  const [directForm, setDirectForm] = useState('');

  const selectAccidentType = (type: string) => {
    setForm((prev) => ({
      ...prev,
      accidentType: type,
    }));
  };

  useEffect(() => {
    if (directForm) {
      setForm((prev) => ({
        ...prev,
        accidentType: directForm,
      }));
    }
  }, [directForm]);

  return (
    <Wrapper>
      <FormTitle title="어떤 사고를 당하셨나요?" />

      <AccidentGrid>
        {ACCIDENT_TYPE.map((accident) => (
          <CommonButton
            key={accident}
            onClick={() => selectAccidentType(accident)}
            isSelected={form.accidentType === accident}
            title={accident}
            size="sm"
          />
        ))}
      </AccidentGrid>

      <StyledInput
        type="text"
        id="place"
        value={directForm}
        onChange={(e) => setDirectForm(e.target.value)}
        placeholder="기타 : 직접 입력해 주세요"
      />
    </Wrapper>
  );
};

export default AccidentForm;

// ======================= styled-components =======================

const Wrapper = styled.div`
  width: 100%;
`;

const AccidentGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-top: 26px;
  @media (min-width: 768px) {
    margin-top: 22px;
    grid-template-columns: repeat(5, 1fr);
  }
`;

const StyledInput = styled.input`
  width: 100%;
  height: 42px;
  margin-top: 12px;
  padding: 10.5px 20px;
  background-color: #f6f7fb;
  border-radius: 16px;
  font-weight: bold;
  font-size: 18px;
  line-height: 27px;
  border: none;
  outline: none;

  @media (min-width: 640px) {
    padding: 14px 40px 13px 40px;
  }

  &::placeholder {
    font-weight: 300;
    color: #999;
  }

  &:focus {
    border: 1px solid #0b46dd; /* focus:border-blue-200 */
  }
`;
